<template>
    <div class="credentialsSection">
        <div class="credentials" v-for="credential in credentials" :key="credential.id">
        <div class="credentialImage">
            <img :src="credential.image" alt="credential.name"/>
            <div class="credentialName">{{ credential.name }}</div>
        </div>
 </div>
    </div>

</template>


<script>
export default {
    name: 'MyCredentials',
    data() {
        return {
            credentials: [
            {
                    id: 1,
                    name: 'Master Craftsman',
                    image: require('@/assets/Badges/MasterCraftsman.png'),
                },
                {
                    id: 2,
                    name: 'Shingle Master',
                    image: require('@/assets/Badges/ShingleMaster.png'),
                },
                {
                    id: 3,
                    name: 'Shingle Master Certified',
                    image: require('@/assets/Badges/MasterShingle.jpg'),
                },
                {
                id: 4,
                name: 'Certainteed',
                    image: require('@/assets/Badges/Certainteed.jpg'),

                },
                {
                    id: 5,
                    name: 'Owens Corning',
                    image: require('@/assets/Badges/Corning.jpg'),
                },
                {
                    id: 6,
                    name: 'IKO',
                    image: require('@/assets/Badges/IKO.jpeg'),
                },
                {
                    id: 7,
                    name: 'EPA Lead-Safe Certified',
                    image: require('@/assets/Badges/lead-safe-certified-firm.png'),
                },
            ],
        };
    },
    
    }
</script>

<style scoped>

.credentialsSection {
    font-family: 'Roboto', sans-serif;
    color: #ffffff;
    line-height: 1.6;
    background: transparent;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;

    @media screen and (max-width: 600px) {
        flex-direction: column;
        align-items: center;
        
    }
}
.credentialImage img {
    width: 200px; /* Adjust as needed */
    height: 150px; /* Adjust as needed */
    border-radius: 10px;  
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);   
    transition: transform 0.3s ease;
    margin-bottom: 10px;

}
.credentialName {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    color: white;
    padding-bottom: 10px;
}
</style>